import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-with-nations export-page" }
const _hoisted_2 = { class: "container-page big" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsYearFilterBlock = _resolveComponent("DashboardsYearFilterBlock")!
  const _component_DateActualDataSubtitle = _resolveComponent("DateActualDataSubtitle")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_VesExportButtons = _resolveComponent("VesExportButtons")!
  const _component_CountTable = _resolveComponent("CountTable")!
  const _component_TableWithOuterFilter = _resolveComponent("TableWithOuterFilter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      dense: "",
      title: "Проекты субъектов РФ в иностранных государствах"
    }, {
      button: _withCtx(() => [
        _createVNode(_component_DashboardsYearFilterBlock, {
          onChangeFilter: _ctx.updateYearFilter,
          filter: _ctx.filter,
          class: "project-with-nations__filter"
        }, null, 8, ["onChangeFilter", "filter"])
      ]),
      subtitles: _withCtx(() => [
        _createVNode(_component_DateActualDataSubtitle, {
          class: "project-with-nations__subtitle",
          filter: _ctx.filter,
          isSimpleYearLabel: ""
        }, null, 8, ["filter"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TableWithOuterFilter, {
        tableConfig: _ctx.getTableConfig,
        filtersConfig: _ctx.getFiltersConfig,
        defaultFilter: _ctx.filter,
        tableClass: "project-with-nations__table",
        onSearchFilter: _ctx.updateTableFilters
      }, {
        "filter-buttons": _withCtx(() => [
          _createVNode(_component_VesExportButtons, {
            onExportExcel: _ctx.exportExcel,
            onExportPdf: _ctx.downloadPDF,
            loading: _ctx.exportInProgress
          }, null, 8, ["onExportExcel", "onExportPdf", "loading"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_CountTable, {
            typeCount: "проектов",
            class: "project-with-nations__count-table",
            storePaths: _ctx.countTableConfig,
            filter: _ctx.filter
          }, null, 8, ["storePaths", "filter"])
        ]),
        _: 1
      }, 8, ["tableConfig", "filtersConfig", "defaultFilter", "onSearchFilter"])
    ])
  ]))
}